export default __webpack_public_path__ + "static/media/single-project-page-05-img-23.1565ea08.jpg";